import { Button, Tooltip } from "@mui/material";
import { useMemo } from "react";
import { AssetRetrieval } from "types/assetRetrieval";

interface AssetRetrievalCancelButtonProps {
  assetRetrieval: AssetRetrieval;
  onClick: () => void;
  disabled?: boolean;
}

const getCancelButtonState = (state: string) => {
  const cancelableStates = ["order_placed", "labels_printed", "package_out_to_employee"];
  const isEnabled = cancelableStates.includes(state);

  if (isEnabled) {
    return {
      enabled: true,
      tooltip: "",
    };
  }

  return {
    enabled: false,
    tooltip: "This order cannot be canceled at its current stage",
  };
};

export function AssetRetrievalCancelButton({
  assetRetrieval,
  onClick,
  disabled = false,
}: AssetRetrievalCancelButtonProps) {
  const { enabled, tooltip } = useMemo(() => getCancelButtonState(assetRetrieval.state), [assetRetrieval.state]);

  const isDisabled = useMemo(() => disabled || !enabled, [disabled, enabled]);

  return !enabled ? (
    <Tooltip title={tooltip}>
      <span>
        <Button variant="outlined" color="error" size="small" onClick={onClick} disabled={isDisabled}>
          Cancel
        </Button>
      </span>
    </Tooltip>
  ) : (
    <Button variant="outlined" color="error" size="small" onClick={onClick} disabled={isDisabled}>
      Cancel
    </Button>
  );
}
